interface TradeRegion {
  id: string;
  name: string;
  countries: string[];
}

export const tradeRegions: TradeRegion[] = [
  {
    id: 'EAST_ASIA',
    name: 'East Asia',
    countries: ['CN', 'JP', 'KR', 'MN', 'HK', 'MO', 'TW'],
  },
  {
    id: 'SE_ASIA',
    name: 'South East Asia',
    countries: ['TH', 'ID', 'MY', 'SG', 'KH', 'VN', 'PH', 'BN', 'LA', 'MM'],
  },
  {
    id: 'CENTRAL_ASIA',
    name: 'Central Asia',
    countries: ['AF', 'AZ', 'KZ', 'KG', 'RU', 'TM', 'UZ'],
  },
  {
    id: 'SOUTH_ASIA',
    name: 'South Asia',
    countries: ['IN', 'PK', 'BD', 'BT', 'TL', 'NP', 'LK', 'SC'],
  },
  {
    id: 'OCEANIA',
    name: 'Oceania',
    countries: ['AU', 'NZ', 'FJ', 'FM', 'NC', 'PG', 'WS', 'TO', 'VU'],
  },
  {
    id: 'NORTH_AMERICA',
    name: 'North America',
    countries: ['US', 'CA', 'MX', 'BS', 'BM', 'CU', 'JM', 'PA', 'BB', 'VG', 'MQ', 'SX', 'GD', 'TT'],
  },
  {
    id: 'SOUTH_AMERICA',
    name: 'South/Central America',
    countries: [
      'BR',
      'AR',
      'BO',
      'CL',
      'CO',
      'CR',
      'DM',
      'DO',
      'EC',
      'GQ',
      'GT',
      'NI',
      'PY',
      'PE',
      'PR',
      'VE',
      'UY',
      'HN',
      'SV',
    ],
  },
  {
    id: 'AFRICA',
    name: 'Africa',
    countries: [
      'DZ',
      'AO',
      'BZ',
      'BJ',
      'BW',
      'BF',
      'BI',
      'CM',
      'CF',
      'TD',
      'CD',
      'DJ',
      'EG',
      'ER',
      'ET',
      'GA',
      'GM',
      'GH',
      'GN',
      'GQ',
      'GY',
      'CI',
      'KE',
      'LS',
      'LR',
      'LY',
      'MG',
      'MW',
      'MU',
      'ML',
      'MA',
      'MZ',
      'NA',
      'NE',
      'NG',
      'CG',
      'RW',
      'SN',
      'SL',
      'SO',
      'ZA',
      'SS',
      'SD',
      'SR',
      'SZ',
      'TZ',
      'TG',
      'TN',
      'UG',
      'ZM',
      'ZW',
    ],
  },
  {
    id: 'MIDDLE_EAST',
    name: 'Middle East',
    countries: ['BH', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'QA', 'SA', 'SY', 'AE', 'YE', 'TR', 'PS'],
  },
  {
    id: 'EUROPE',
    name: 'Europe',
    countries: [
      'AT',
      'AM',
      'AL',
      'UK',
      'GB',
      'BY',
      'BE',
      'BA',
      'BG',
      'HR',
      'CY',
      'CS',
      'CZ',
      'EE',
      'FI',
      'FR',
      'GE',
      'DE',
      'DK',
      'GI',
      'GR',
      'GL',
      'HU',
      'IS',
      'IE',
      'IT',
      'LV',
      'LI',
      'LT',
      'LU',
      'MK',
      'MT',
      'MD',
      'MC',
      'ME',
      'MS',
      'NL',
      'NO',
      'PL',
      'PT',
      'RO',
      'RS',
      'SI',
      'SE',
      'SM',
      'SK',
      'ES',
      'CH',
      'UA',
    ],
  },
];
